import axios from "axios";
import { showErrorToast } from "../../utils/toastUtils";

export const apiGetNonBOAProductsList = (keyword) => {
  keyword = keyword !== "" ? keyword : null;
  const data = {
    SearchParam: keyword,
  };
  return axios.get("/api/NonBOAProducts", { params: data }).then((result) => {
    if (result) {
      if (result.data) {
        const data = result.data;
        return data.nonBOAProducts;
      }
    }
    return false;
  });
};

export const apiGetNonBOAProduct = (id) => {
  return axios.get(`/api/NonBOAProducts/${id}`).then((result) => {
    if (result && result.data) {
      let data = result.data;
      return data;
    }
    return false;
  });
};

export const apiAddNonBOAProduct = async (data) => {
  data.buyPrice = data.buyPrice
    ? Number(data.buyPrice)
    : data.buyPrice === 0 || data.buyPrice === "0"
    ? 0
    : null;
  data.sellPrice = data.sellPrice
    ? Number(data.sellPrice)
    : data.sellPrice === 0 || data.sellPrice === "0"
    ? 0
    : null;
  return axios
    .post(`/api/NonBOAProducts`, data)
    .then((result) => {
      if (result && result.data) {
        const resultData = result.data;
        const nonBOAProduct = resultData.nonBOAProducts?.find(
          (item) => item.barcode === data.barcode
        );
        return nonBOAProduct;
      }
      return false;
    })
    .catch((error) => {
      // Handle error response
      if (error.response.data) {
        const data = error.response.data;
        showErrorToast(data?.description);
        return false;
      } else {
        console.log("Error:", error.message);
      }
      return false;
    });
};

export const apiUpdateNonBOAProduct = async (data) => {
  data.buyPrice = data.buyPrice
    ? Number(data.buyPrice)
    : data.buyPrice === 0 || data.buyPrice === "0"
    ? 0
    : null;
  data.sellPrice = data.sellPrice
    ? Number(data.sellPrice)
    : data.sellPrice === 0 || data.sellPrice === "0"
    ? 0
    : null;
  if (data.isSyncedToXero) {
    data.syncToXero = false;
  }
  delete data.isSyncedToXero;
  return axios
    .put(`/api/NonBOAProducts/${data.id}`, data)
    .then((result) => {
      if (result && result.data) {
        const resultData = result.data;
        const nonBOAProduct = resultData.nonBOAProducts?.find(
          (item) => item.barcode === data.barcode
        );
        return nonBOAProduct;
      }
      return false;
    })
    .catch((error) => {
      // Handle error response
      if (error.response.data) {
        const data = error.response.data;
        showErrorToast(data?.description);
        return false;
      } else {
        console.log("Error:", error.message);
      }
      return false;
    });
};

export const apiDeleteNonBOAProduct = async (id) => {
  return axios.delete(`/api/NonBOAProducts/${id}`).then((result) => {
    if (result && result.status) {
      if (result.status === 200 || result.status === 204) return true;
    }
    return false;
  });
};

export const apiNonBOAProductUploadFile = async (file, id) => {
  const formDataParam = new FormData();

  formDataParam.append("file", file);
  return axios
    .post(`/api/NonBOAProducts/upload-file/${id}`, formDataParam, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((result) => {
      if (result && result.data) {
        return result.data;
      }
      return false;
    })
    .catch((error) => {
      // Handle error response
      console.log(error);
      if (error.response.data) {
        console.log(error.response.data);
        const data = error.response.data;
        showErrorToast(data?.message);
        if (data.statusCode === 400) return false;
        if (data.statusCode === 500) return false;
        return false;
      } else {
        console.log("Error:", error.message);
      }
      return false;
    });
};

export const apiNonBOAProductDeleteFile = async (fileId, id) => {
  const payload = {
    product_id: id,
    file_id: fileId,
  };
  return axios
    .delete(`/api/NonBOAProducts/delete-file`, { params: payload })
    .then((result) => {
      if (result && result.data) {
        return result.data;
      }
      return false;
    })
    .catch((error) => {
      // Handle error response
      if (error.response.data) {
        const data = error.response.data;
        if (data.statusCode === 500) return false;
        return data;
      } else {
        console.log("Error:", error.message);
      }
      return false;
    });
};

export const apiSaveNonBOAProductsBulk = async (data) => {
  data.map((item) => {
    item.buyPrice = item.buyPrice
      ? Number(item.buyPrice)
      : item.buyPrice === 0 || item.buyPrice === "0"
      ? 0
      : null;
    item.sellPrice = item.sellPrice
      ? Number(item.sellPrice)
      : item.sellPrice === 0 || item.sellPrice === "0"
      ? 0
      : null;
  });
  const postData = { nonBOAProducts: data };
  return axios
    .post(`/api/NonBOAProducts/bulk-upload`, postData)
    .then((result) => {
      console.log(result);
      if (result) {
        if (result.status === 204) return true;
        if (result.data) return result.data;
        return true;
      }
      return false;
    })
    .catch((error) => {
      // Handle error response
      if (error.response.data) {
        const data = error.response.data;
        showErrorToast(data?.description);
        return false;
      } else {
        console.log("Error:", error.message);
      }
      return false;
    });
};

export const apiGetSyncWithXeroList = () => {
  return axios.get("/api/NonBOAProducts/sync-with-xero").then((result) => {
    if (result) {
      console.log(result);
      if (result.data) {
        return result.data;
      }
    }
    return false;
  });
};

export const apiSyncWithXero = async (syncFromBOA, toCreate, toUpdate) => {
  const postData = { toCreate: toCreate, toUpdate: toUpdate };
  return axios
    .post(
      `/api/NonBOAProducts/sync-with-xero?syncFromBOA=${syncFromBOA}`,
      postData
    )
    .then((result) => {
      console.log(result);
      if (result) {
        if (result.status === 204) return true;
        if (result.data) return result.data;
        return true;
      }
      return false;
    });
};
